import CustomAssetWrapper from "./CustomAssetWrapper";

export default CustomAssetWrapper;